
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AeAutocomplete from "@/components/common/Autocomplete.vue";
import { roleService } from "@/app/services/role.service";
import AutocompleteWithErrors from "@/app/components/AutocompleteWithErrors.vue";
import { DynamicFormEntry } from "@/app/dynamic-components/forms/dynamic-form.model";
import { dossierServiceV2 } from "@/app/services/dossier.service";
import {organisationService} from "@/app/services/organisation.service";
import {ruleEngine} from "@/app/services/rule.engine";
import {exchangeService} from "@/app/services/exchange.service";
import {productService} from "@/app/services/product.service";
import {checkinService} from "@/app/services/checkin.service";
import {planningService} from "@/app/services/planning.service";
import {scheduleService} from "@/app/services/schedule.service";
import {documentServiceV2} from "@/app/services/document.service";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";
import {partyService} from "@/app/services/party.service";

export type SelectOrgInRoleMetaData = {
  roleIds?: string[];
  addAsParty: boolean
};

@Component({
  components: {DynamicComponentConfigManager, AutocompleteWithErrors, AeAutocomplete },
})
export default class FormComponentSelectOrgInRole extends BaseDynamicComponent<SelectOrgInRoleMetaData> {
  orgs: string[] | string = [];
  eligibleOrganistions: { name: string; id: string }[] = [];
  loadingElegableOrganistions = false;

  postEntityChanged(entry: DynamicFormEntry) {
    if (
      entry &&
      Array.isArray(entry?.metadata?.roleIds) &&
      Array.from(entry?.metadata?.roleIds).length > 0
    ) {
      roleService
        .getEligableOrganisations(Array.from(entry?.metadata?.roleIds)[0])
        .then((eligibleOrganistions) => {
          this.eligibleOrganistions = eligibleOrganistions;
        })
        .catch((reason) => {
          console.warn(
            "Failed to fetch EligableOrganisations for " +
              Array.from(entry?.metadata?.roleIds)[0] +
              " " +
              reason
          );
          this.eligibleOrganistions = [];
        });
    } else {
      this.eligibleOrganistions = [];
    }
  }

  get displayOrganisations(): string {
    return this.eligibleOrganistions
      .filter((eligibleOrg) => this.orgs.includes(eligibleOrg.id))
      .map((org) => org.name)
      .join(", ");
  }

  @Watch("orgs")
  onOrgsChanged() {
    this.setValueView(this.orgs);
  }
  postSetValueView(value: any) {
    if (value !== this.orgs) {
      this.orgs = value;
    }
  }

  async afterSave(sumbitData: any): Promise<boolean> {
    if (!sumbitData?.type) return true;
    if (!sumbitData?.referenceId) return true;
    if (!this.entry?.value) return true;

    // sumbitData.type === "dossier" is legacy code, addAsParty should be enable on these in the future
    if(sumbitData.type === "dossier" || await ruleEngine.resolveRuleAsync(this.getContext(), this.metadata?.addAsParty || false, this)){
      let val = this.entry.value;
      if(!Array.isArray(val)){
        val = [val];
      }
      for (let contactId of val) {
        await partyService.addOrg(sumbitData.type, sumbitData.referenceId, contactId as string, this.entry?.metadata?.roleIds? this.entry?.metadata?.roleIds[0] : undefined);
      }
    }
    return true;
  }

  public async fillIndexerValue(indexerField: string, indexerSelector): Promise<any> {
    if('orgs' === indexerSelector){
      if(this.orgs && Array.isArray(this.orgs)){
        let filteredOrgs = this.eligibleOrganistions.filter((org) => this.orgs.includes(org.id));
        if(filteredOrgs.length < this.orgs.length){
          //this can happen with computed values, as elegable onlu checks first roleid
          const fetchedOrgs = await organisationService.getOrganisationsByIds(this.orgs);
          filteredOrgs = fetchedOrgs.map(value => {
            return {
              name: value.name,
              id: value.id
            }
          });
        }
        return filteredOrgs
            .map((org) => org.name)
            .join(", ") || "";
      }else if(typeof this.orgs === 'string'){
        let filteredOrgs = this.eligibleOrganistions.filter((org) => org.id === this.orgs);
        if(filteredOrgs.length < 1){
          //this can happen with computed values, as elegable onlu checks first roleid
          const fetchedOrgs = await organisationService.getOrganisationsByIds([this.orgs]);
          filteredOrgs = fetchedOrgs.map(value => {
            return {
              name: value.name,
              id: value.id
            }
          });
        }
        return filteredOrgs
            .map((org) => org.name)
            .join(", ") || "";
      }
    }

    return super.fillIndexerValue(indexerField, indexerSelector);
  }
}
